import { render, staticRenderFns } from "./document-table.vue?vue&type=template&id=0745d063&scoped=true&"
import script from "./document-table.ts?vue&type=script&lang=ts&"
export * from "./document-table.ts?vue&type=script&lang=ts&"
import style0 from "./document-table.scss?vue&type=style&index=0&id=0745d063&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0745d063",
  null
  
)

export default component.exports